import { UseFormRegister } from 'react-hook-form';

import React from 'react';

interface IconSelectProps {
  label?: string;
  name: string;
  value?: string;
  onChange?: (value: string) => void;
  register?: UseFormRegister<any>;
  className?: string;
  strokeColor?: string;
  icons: Array<{
    id: string;
    name: string;
    component: React.ComponentType<{ width?: number; height?: number; strokeColor?: string }>;
  }>;
  error?: string;
}

const IconSelect = React.forwardRef<HTMLDivElement, IconSelectProps>(
  (
    { label = 'Select your budget icon', name, value, onChange, className = '', strokeColor = '#495057', icons, error },
    ref
  ) => {
    return (
      <div ref={ref} tabIndex={-1} className={`${className} outline-none`}>
        {label && <label className="inline-block text-[#495057] font-medium text-xs md:text-lg mb-2">{label}</label>}
        <div
          className={`mt-[0.2rem] flex items-start justify-between md:justify-start gap-3 ${error ? 'border border-red-200 rounded-lg w-fit' : ''}`}
        >
          {icons.map((icon) => {
            const IconComponent = icon.component;
            return (
              <button
                type="button"
                className={`border rounded-[16px] w-[98px] h-[96px] flex items-center justify-center bg-white p-3
              ${value === icon.id ? 'border-primary' : 'border-white hover:border-[#ADB5BD]'}`}
                key={icon.id}
                onClick={() => onChange?.(icon.id)}
              >
                <IconComponent width={50} height={50} strokeColor={strokeColor} />
              </button>
            );
          })}
        </div>
        <input type="hidden" name={name} value={value || ''} />
      </div>
    );
  }
);

IconSelect.displayName = 'IconSelect';

export default IconSelect;
